import React, { useState, useEffect, useCallback } from "react";
import MobileViewHome from "./components/MobileView";
import DesktopHome from "./DesktopHome";
import { Howl } from "howler";
import $ from "jquery";

let currSound = {};

const App = () => {
  const [state, setState] = useState({
    isMobileView: null,
  });
  const [isMuted, setIsMuted] = useState(true);


  /*
Cookie Banner :)

*/

  // Cookie Banner
  let banner = "<div id=\"stagrBanner\"> <div class=\"copy\"> <p>We use cookies to ensure that we give you the best experience on our website.</p><p>If you would like to find out more about the cookies we use and how to disable them, you can access our <a href='https://www.stagrallergy.com/privacy-policy/' target='_blank'>Cookie Policy</a>. By continuing your visit on the website, you consent to the use of the cookies.</p></div><button id=\"stagr-agree\">Accept</button> <span class=\"close-banner\"><img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABHNCSVQICAgIfAhkiAAAAXxJREFUOE+V1L8rhXEUx/H3x2LAIKPRP6DIz+nKXZRsZJEfg2w2NjY2dllMJgY/SqIsRoNSynJHGWyKUkdfzsPje5/nuc+9y617+r76nPM93ysAM1sBBoEFSRZ+K/sxs15gF5iW9CIzWwe2HDgA5suijl0DncATMB7ATWAjlagUGmHheA2oyFtuCjWzEeDUk/1hUu0bbAZ17AJo96M/yaTwzS/o6DawFrW/JOnT6yFZLlYH+qEdYDWFHocbBAYaYZlgDnoD9OW1mV6xfy2nC2YWJ03Kz8BwMrN4X3NBT3oIzKQOvQP9kh7yFr8oYXwBifE90+SiSiU0sypwlJrZG9AWX1QWWpfQsROg1YEwswqwnHX7MRrvYUhWh0l69JnuA4tFSdMvpRBzsAXYK0KTt9wQSz3RPHRW0kf4t4mxV2A0aTNrPcwsC70EJgN4Bkz4wYBVJd3l7VlB0rCjYwHsAK6AnrJYBjoHTEk6T2bYBXRLum+ULK57+0OSbkPtCy+awIezZwoYAAAAAElFTkSuQmCC\" alt=\"close\"></span></div>";

  let styles = "<style>#stagrBanner{width:100%;padding:25px 0;vertical-align:center;background-color:#18679a;visibility:hidden;position:fixed;bottom:-100%;transition:all 1s ease;transition-delay:.25s;opacity:0;color:#fff;z-index:9999999999999999}#stagrBanner.show{bottom:0;visibility:visible;opacity:1;transition-delay:1s}#stagrBanner .copy{max-width:80%;display:inline-block;font-size:24px;padding:0 25px}#stagrBanner .copy a{color:#fff!important; text-decoration:underline;}#stagrBanner .copy p{max-width:90%;margin:10px auto}#stagrBanner button{background-color:#cad44a;color:#18679a;padding:25px 50px;box-shadow:3px 3px 3px rgba(0,0,0,.3);font-family: Montserrat,sans-serif !important;border-style: solid;font-size:20px;display:inline-block;vertical-align:text-bottom;position:absolute;top:35%}#stagrBanner a button:hover{background-color:#fff;color:#cad44a;box-shadow:0 0}#stagrBanner .close-banner{padding:25px;cursor:pointer;display:inline-block;vertical-align:text-bottom;position:absolute;top:35%;right:3%}@media(max-width:1919px){#stagrBanner .close-banner{top:10px;right:10px}}@media(max-width:1260px){#stagrBanner .copy{max-width:70%}#stagrBanner button{position:absolute;top:35%}#stagrBanner .close-banner{position:absolute;top:10px;right:0}}@media(max-width:768px){#stagrBanner .copy{width:100%;display:block;max-width:85%}#stagrBanner button{display:block;width:90%;margin:0 auto;position:relative}}@media(max-width:450px){#stagrBanner .copy{font-size:18px}}#leaving-modal{position:fixed;left:0;width:100%;height:100%;background:rgba(0,0,0,.7);top:-100%;opacity:0;transition:all 1s ease;z-index:999999999999999}#leaving-modal .modal-content{position:absolute;top:-100%;width:64%;border-radius:15px;left:18%;min-height:200px;background-color:#fff}#leaving-modal.show{top:0;opacity:1}#leaving-modal.show .modal-content{top:13%}#leaving-modal .modal-top h2{padding:25px 30px 0;margin-bottom:10px;font-size:38px;font-family:Montserrat}#leaving-modal .modal-top .close-leaving-modal{position:absolute;top:35px;right:35px;cursor:pointer}#leaving-modal .modal-copy{border-top:1px solid #707070;border-bottom:1px solid #707070;max-height:40%}#leaving-modal .modal-copy p{font-size:24px;font-family:Montserrat;padding:25px 30px}#leaving-modal .modal-confirm{background-color:#e5e5e5;border-radius:0 0 15px 15px;padding:10px 0 0}#leaving-modal .modal-confirm p{font-size:20px;color:#333;display:inline-block;padding:40px 30px;font-family:Montserrat;cursor:pointer}#leaving-modal .modal-confirm button{background-color:#cad44a;color:#18679a;padding:25px 50px;box-shadow:3px 3px 3px rgba(0,0,0,.3);font-family:Montserrat;font-size:20px;display:inline-block;cursor:pointer;border:0;margin:0 35px}#leaving-modal .modal-confirm button a{text-decoration:none;color:inherit}@media(max-width:650px){#leaving-modal .modal-content{top:5%;width:95%;left:2.5%}#leaving-modal .modal-top h2{padding:15px 25px 0;margin-bottom:10px;font-size:28px}#leaving-modal .modal-copy p{font-size:14px;font-family:Montserrat;padding:20px 15px}#leaving-modal .modal-confirm{border-radius:0 0 15px 15px}#leaving-modal .modal-confirm p{font-size:18px;padding:10px 15px}#leaving-modal .modal-confirm button{padding:15px 30px;font-family:Montserrat;font-size:18px;margin:0 15px}}#leaving-modal .modal-confirm button:hover{background-color:#fff;color:#cad44a;box-shadow:0 0;text-shadow:1px 1px 1px rgba(0,0,0,.2)}@media(max-height:685px){#leaving-modal .modal-content{top:0;width:95%;left:2.5%}#leaving-modal .modal-top h2{padding:15px 25px 0;margin-bottom:10px;font-size:28px}#leaving-modal .modal-copy p{font-size:14px;font-family:Montserrat;padding:20px 15px}#leaving-modal .modal-confirm{border-radius:0 0 15px 15px}#leaving-modal .modal-confirm p{font-size:18px;padding:10px 15px}}@media(max-width:450px){#leaving-modal .modal-top .close-leaving-modal{position:absolute;top:15px;right:15px;cursor:pointer}#leaving-modal .modal-content{top:1%}#leaving-modal .modal-top h2{font-size:18px}}</style>";




  function stagrBannerCookie() {

    $('body').append(banner);
    $('head').append(styles);
    function showBanner() {
      document.getElementById('stagrBanner').classList.add('show');

    }
    function closeBanner() {
      document.getElementById('stagrBanner').classList.remove('show');
    }
    function checkCookie() {
      let doesCookieExit = document.cookie.indexOf('stagrBannerAgree') > -1 ? true : false;
      return doesCookieExit;
    }
    function setCookie() {
      let now = new Date();
      let time = now.getTime();
      let numOfDays = 365;
      let expireTime = time + 100*36000*24*numOfDays;
      now.setTime(expireTime);
      document.cookie = 'stagrBannerAgree=true;expires='+now.toUTCString()+';path=/';
      closeBanner();
    }

    let isCookie = checkCookie();
    if(!isCookie && document.getElementById('stagrBanner')) {
      showBanner();
      document.getElementById('stagr-agree').addEventListener('click', function() {
        setCookie();
      })
      $('.close-banner').each(function(i,c){
        c.addEventListener('click', closeBanner);
      })
    }
    console.log('did call');
  }
  stagrBannerCookie();

  useEffect(() => {
    setState({ ...state, isMobileView: window.innerWidth <= 768 });
    window.addEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleAudioMute = (flag) => {
    if (currSound.pause) {
      if (flag) {
        currSound.pause();
      }
      setIsMuted(flag);
    }
  };
  const playAudio = useCallback((state) => {
    let audioPath =
      state.jsonDataObj.menu && state.currentScreen === -1
        ? state.jsonDataObj.menu[0]["audio"]
        : !!state.currentStepData
          ? state.currentStepData.audio
          : "";
    if (currSound.pause && isMuted) currSound.pause();
    if (!!state.currentStepData) {
      setTimeout(function () {
        if (!currSound.playing) {
          currSound = new Howl({
            src: [audioPath],
            autoplay: false,
            loop: true,
            volume: 1,
            pool: 3,
            onload: function () {
              let id1 = !isMuted ? currSound.play() : currSound.pause();
              if (!isMuted) {
                currSound.fade(0, 1, 5000, id1);
              }
            },
          });
        } else {
          if (!isMuted) {
            currSound.fade(1, 0, 5000);
          }

          currSound = new Howl({
            src: [audioPath],
            autoplay: false,
            loop: true,
            volume: 1,
            pool: 3,
            onload: function () {
              let id2 = !isMuted ? currSound.play() : currSound.pause();
              if (!isMuted) {
                currSound.fade(0, 1, 5000, id2);
              }
            },
          });
        }
      }, 200);
    }

    if (!!state.currentStepData === false && currSound) {
      currSound.pause();
    }
  }, [isMuted]);

  const handleResize = () => {
    setState({ ...state, isMobileView: window.innerWidth <= 768 });
  };

  React.useEffect(() => {
    if (state.isMobileView && currSound.play) {
      currSound.play();
    } else {
      if (currSound.pause) currSound.pause();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.isMobileView]);

  if (state.isMobileView === null) return null;
  return state.isMobileView === true ? (
    <MobileViewHome
      playAudio={playAudio}
      currSound={currSound}
      setIsMuted={(flag) => {
        setIsMuted(flag);
      }}
      handleAudioMute={handleAudioMute}
      isMuted={isMuted}
    />
  ) : (
      <DesktopHome />
    );
};
export default App;
